//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 20.07.2015.
 */

(function () {
  "use strict";

  angular
    .module("container.components")
    .directive("srsngClipboard", srsngClipboard);

  function srsngClipboard() {
    return {
      restrict: "E",
      scope: {
        visible: "=",
      },
      templateUrl: "container/ui/app/components/clipboard/clipboard.html",
      controller: controller,
            link: link
    };

    function controller($scope, clipboardService) {
      $scope.texts = clipboardService.clipboardTexts;

      $scope.$on("clipboard:change", function (event, data) {
        $scope.texts = data;
      });

      $scope.removeAll = function () {
        clipboardService.removeAll();
      };

      $scope.removeText = function (text) {
        clipboardService.remove(text);
      };

      $scope.hide = function () {
        $scope.visible = false;
      };
    }

        function link(scope, element, attrs) {
            // this is intentional override

        }
  }
})();
